import { keywords } from '../parser/keywords.js';
import { getDecoratorInfo } from './decoratorUtils.js';

/**
 * Decorator to assign a custom display title to a test class or function.
 * 
 * @param title - The custom title string.
 */
export function testTitle(title: string) {

  return function (targetProto: any, childKey?: string) {
    const decInfo = getDecoratorInfo(childKey);

    if (decInfo.isClass) {
      targetProto[keywords.title] = title;
      return;
    }

    const target = targetProto[decInfo.key!];
    const isFunction = target instanceof Function;
    if (isFunction == false) return;

    target[keywords.title] = title;
  }

}
